export default __webpack_public_path__ + "static/media/RotaryTillerimg.c7e588f0.jpg";